module.exports = __webpack_public_path__ + "static/media/payment.c868fcdf.svg";